import HistoryGridCard from "./HistoryGridCard";

export default function HistoryGrid({ rows }) {
  return (
    <div className="w-full min-h-0 flex-1 flex flex-col gap-4 overflow-y-auto mb:hidden">
      {rows.map((row) => (
        <HistoryGridCard key={row.id} {...row} />
      ))}
    </div>
  );
}
